import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';

export interface ProjectProgress {
  done: number;
  total: number;
}

/**
 * One read for the Home project grid: open/completed counts per visible
 * project. RLS trims the rows to what the person can see anyway.
 */
export function useProjectProgress(projectIds: string[]) {
  const { client } = useAuth();
  const key = [...projectIds].sort().join(',');
  return useQuery({
    queryKey: ['home', 'progress', key],
    enabled: projectIds.length > 0,
    retry: false,
    queryFn: async () => {
      const { data, error } = await client
        .from('tasks')
        .select('project_id, is_completed')
        .in('project_id', projectIds);
      if (error) {
        throw new Error(error.message);
      }
      const map = new Map<string, ProjectProgress>();
      for (const row of data ?? []) {
        // Deal tasks carry no project, so they belong to no project's bar.
        if (row.project_id === null) {
          continue;
        }
        const entry = map.get(row.project_id) ?? { done: 0, total: 0 };
        entry.total += 1;
        if (row.is_completed) {
          entry.done += 1;
        }
        map.set(row.project_id, entry);
      }
      return map;
    },
  });
}
